import { mergeProps } from '@base-ui/react/merge-props';
import { useRender } from '@base-ui/react/use-render';
import * as stylex from '@stylexjs/stylex';
import * as React from 'react';
import './tokens.stylex';
import { maxColumnGridTokens } from './tokens.stylex';
import '../../styles/tokens.stylex';
import { columnWidth, spacing, VP } from '../../styles/tokens.stylex';

//#region MaxColumnGrid

export interface MaxColumnGridProps extends useRender.ComponentProps<'section'> {
  maxColumns?: number;
  children?: React.ReactNode;
  styles?: stylex.StyleXStyles;
  gap?: keyof typeof gridGap;
  minColumnWidth?: keyof typeof minColWidth;
  columnBehaviour?: 'auto-fit' | 'auto-fill';
  alignContent?: keyof typeof alignGridContentStyles;
}
export function MaxColumnGrid({
  maxColumns,
  minColumnWidth = 'md',
  columnBehaviour = 'auto-fill',
  gap = 'md',
  render,
  styles,
  alignContent,
  ...props
}: MaxColumnGridProps) {
  const elementStyles = stylex.props(gridGap[gap], minColWidth[minColumnWidth], sx.root(maxColumns, columnBehaviour), alignContent && alignGridContentStyles[alignContent], styles);
  const element = useRender({
    defaultTagName: 'div',
    render,
    props: mergeProps(elementStyles, props)
  });
  return element;
}
const gridGap = {
  none: {
    "--xyd4udo": "xtvdf15",
    $$css: true
  },
  sm: {
    "--xyd4udo": "xebg3ww",
    $$css: true
  },
  md: {
    "--xyd4udo": "x1k78v7f",
    $$css: true
  },
  lg: {
    "--xyd4udo": "x7uy137",
    $$css: true
  }
};
const minColWidth = {
  xs: {
    "--x1mgqjin": "xk3uqbm xtqdqw0",
    $$css: true
  },
  sm: {
    "--x1mgqjin": "x21qj6u",
    $$css: true
  },
  md: {
    "--x1mgqjin": "xnacgzl",
    $$css: true
  },
  lg: {
    "--x1mgqjin": "xz9rlb6",
    $$css: true
  },
  xl: {
    "--x1mgqjin": "xdcltva",
    $$css: true
  }
};
const alignGridContentStyles = {
  start: {
    kfiyM8: "x10ukxgv",
    $$css: true
  },
  center: {
    kfiyM8: "xc26acl",
    $$css: true
  },
  end: {
    kfiyM8: "x4465f1",
    $$css: true
  },
  spaceBetween: {
    kfiyM8: "xcdzlcm",
    $$css: true
  },
  spaceAround: {
    kfiyM8: "x1jpljmv",
    $$css: true
  },
  spaceEvenly: {
    kfiyM8: "xmsuk3y",
    $$css: true
  }
};
const _temp = {
  kOIVth: "xafk9lm",
  k1xSpc: "xrvj5dj",
  "--xlf67dp": "xglxw13",
  "--xtpmlzj": "x1wpot7d",
  kumcoG: "xqketvx",
  "$$css": true
};
const sx = {
  root: (maxColumns: MaxColumnGridProps['maxColumns'], columnBehaviour: MaxColumnGridProps['columnBehaviour']) => [_temp, {
    "--xzp9k29": (maxColumns ?? null) != null ? "xweyz8f" : maxColumns ?? null,
    $$css: true
  }, {
    "--x---xzp9k29": (maxColumns ?? null) != null ? maxColumns ?? null : undefined,
    "--x-gridTemplateColumns": `repeat(${columnBehaviour}, minmax(${maxColumnGridTokens.gridColMinSizeCalc}, 1fr))` != null ? `repeat(${columnBehaviour}, minmax(${maxColumnGridTokens.gridColMinSizeCalc}, 1fr))` : undefined
  }]
};

//#endregion